import {
  SignInPage,
} from '@backstage/core-components';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { microsoftAuthApiRef } from '@backstage/core-plugin-api';

export const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props =>
      (
        <SignInPage
            {...props}
            auto
            provider={{
                id: 'entra-auth-provider',
                title: 'Azure Entra',
                message: 'Sign in using Azure Entra',
                apiRef: microsoftAuthApiRef,
            }}
        />
      ),
  },
});